export const WEIGHT_PICTURE = 0.24;
export const WEIGHT_EASEL_WOOD = 0.15;
export const WEIGHT_EASEL_ALUMINIUM = 0.8;
export const WEIGHT_FRAME = 0.4;
export const WEIGHT_COLOR_PACK = 0.21;

export const ID_FRAME = 0;
export const ID_FRAME_ASSEMBLED = 177;
export const ID_EASEL_WOOD = 151;
export const ID_EASEL_ALUM = 152;
export const ID_BRANDED_BAG = 219;
export const ID_COLOR_PACK = 220;
export const ID_SHIPPING = 221;
export const ID_SHIPPING_BIH = 1222;

export const CODE_FRAME = "FRAME";
export const CODE_FRAME_ASSEMBLED = "FRAME-ASSEMBLED";
export const CODE_EASEL_WOOD = "EASEL-WOOD";
export const CODE_EASEL_ALUM = "EASEL-ALUMINIUM";
export const CODE_COLOR_PACK = "COLOR-PACK";
export const CODE_BRANDED_BAG = "BRANDED-BAG";
export const CODE_SHIPPING = "SHIPPING";
export const CODE_SHIPPING_BIH = "SHIPPING_BIH";

export const ADDITIONAL_EQUIPMENT_IDs = [
  ID_FRAME,
  ID_FRAME_ASSEMBLED,
  ID_EASEL_WOOD,
  ID_EASEL_ALUM,
  ID_COLOR_PACK,
  ID_BRANDED_BAG,
  ID_SHIPPING,
  ID_SHIPPING_BIH,
];

export const REGULAR_PIC_CATEGORIES = [1, 3, 4, 5, 6];
export const KIDS_CATEGORY = 7;
export const ADDITIONAL_EQUIPMENT_CATEGORY = 8;
export const SPEC_CATEGORIES = [KIDS_CATEGORY, ADDITIONAL_EQUIPMENT_CATEGORY];

export const BIH_PRICE_MESSAGE =
  "Konačna cijena može neznatno varirati uslijed promjena kursa.";

export const BIH_MAX_ORDER_PRICE_KM = 279;
export const BIH_WARNING_ORDER_PRICE_KM = 200;
export const BIH_PRICE_LIMIT_MESSAGE = (currentPriceKM: string) =>
  `Maksimalna vrijednost po paketu ne smije biti veća od ${BIH_MAX_ORDER_PRICE_KM} KM.\nVrednost vašeg trenutnog paketa je: ${currentPriceKM}.`;

export type Currency = "DIN" | "KM";

export const FRAME_ASSEMBLED_BIH_WARNING_HEADER =
  "Sklopljen ram nije dostupan za BIH";
export const FRAME_ASSEMBLED_BIH_WARNING_MESSAGE =
  "Sklopljen (blind) ram sa postavljenim platnom trenutno nismo u mogućnosti da šaljemo za Bosnu i Hercegovinu. Da li hoćete da ih izbacite iz porudžbine ili da promenite u rasklopljen ram.";
